import { useEffect, useState } from "react";

export const useWidth = () => {
  const [width, setWidth] = useState<number>();

  useEffect(() => {
    setWidth(window?.innerWidth);
    window?.addEventListener("resize", () => setWidth(window?.innerWidth));

    return () => {
      window?.removeEventListener("resize", () => setWidth(window?.innerWidth));
    };
  }, [width]);

  const isDesktop = width! > 992;
  const isMobile = !isDesktop

  return {
    width,
    isDesktop,
    isMobile,
  };
};
